import React from "react";
import { getBackgroundColor } from "../../../../../utils/statusUtils";

const InfoTable = ({shift}: any) => {
    const shiftStyle = {
        backgroundColor: getBackgroundColor(shift.shiftStatus)
    };

    return (
        <>
            <div className="location-table">
                <div className="location-header font-600 text-align-right" style={{ ...shiftStyle, borderLeft: '0.5px solid black' }}>
                    Location:
                </div>
                <div className="location-header font-600" style={{ ...shiftStyle }}>
                    {shift.location}
                </div>
                <div className="location-header text-align-right" style={{ ...shiftStyle }}>
                    <div className="font-600"> POST CODE:</div>
                </div>
                <div className="location-header font-600" style={{ ...shiftStyle }}>
                    {shift.postCode}
                </div>
            </div>
            <div className="info-table">
                <div className="info-header">
                    <div className="font-600 text-align-right">Job:</div>
                </div>
                <div className="info-data flex-direction-column">
                    {shift.description}
                    <br />
                    <div className="font-600 red-text">{shift.additionalInformation}</div>
                </div>
                <div className="info-header">
                    <div className="text-align-right font-600">Vehicles/Plant:</div>
                </div>
                <div className="info-data flex-direction-column">
                    {shift.plants_Materials}
                </div>
            </div>
        </>
    )
}

export default InfoTable;
